// void 0 = undefined
// create foreach for other browsers than chrome
void 0 === NodeList.prototype.forEach && (NodeList.prototype.forEach = function(e) {
    [].forEach.call(this, e)
});

// Debouncing function to avoid killing the browser

function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

// Throttling function to set a maximum rate frequency when calling a function

function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last,
      deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date,
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}


// Mega function to check inputs on forms

function checkInput(node) {

	// Initialisation des variables
	var retour = true,
		erreur = erreurInt = erreurEmail = radioChecked = false,
		type = (typeof node.attr('data-type') != 'undefined') ? node.attr('data-type') : '',
		pluriel = (typeof node.attr('data-pluriel') != 'undefined') ? true : false,
		mettreEtoile = (typeof node.attr('data-etoile') != 'undefined') ? true : false,
		typeInput = (typeof node.attr('type') != 'undefined') ? node.attr('type') : '',
		msgErreurVide = 'Veuillez saisir ' + (pluriel === true ? 'vos' : 'votre') + ' ',
		msgErreurInt = ' avec un nombre entier',
		msgErreurEmail = ' avec un email valide';

	
	$((typeInput === 'radio' ? 'input[data-oblig=1][name=' + node.attr('name') + ']' : node)).each(function() {
		$parent = $(this).parent();
		$aModifier = $parent.find((typeInput === 'radio' ? 'span[id=' + $(this).attr('name') + ']' : 'label[for=' + $(this).attr('id') + ']'));
		
		// Remise à zero
		$(this).removeClass('error'); $(this).removeClass('valid');
		$parent.removeClass('error');
		$aModifier.html($aModifier.html().replace(msgErreurVide, ''));
		$aModifier.html($aModifier.html().replace(msgErreurInt, ''));
		$aModifier.html($aModifier.html().replace(msgErreurEmail, ''));
		
		if (mettreEtoile === true) {
			$aModifier.html($aModifier.html() + ' *');
			node.removeAttr('data-etoile');
		}

		// Détection de l'erreur
		if (typeInput === 'radio') {
			if (radioChecked != true && $(this).is(':checked') === true) {
				radioChecked = true;
			}
			
			erreur = (radioChecked === true) ? false : true;
		} else {
			if ($(this).val() == '' || $(this).val() == null || (typeInput === 'checkbox' && $(this).is(':checked') === false)) {
				erreur = true;
			} else {
				if (type == 'int' && $(this).val().match(/^[0-9]*$/) == null) {
					erreur = erreurInt = true;
				}
				
				if (type == 'email' && $(this).val().toLowerCase().match(/^[a-zA-Z0-9][a-zA-Z0-9._-]*@([a-zA-Z][a-zA-Z0-9_\-]*\.)*[a-z0-9]+[a-z0-9\-]+\.[a-z]{2,6}$/) == null) {
					erreur = erreurEmail = true;
				}
			}
		}
		
		// Gestion de l'erreur
		if (erreur == true) {
			$(this).removeClass('valid').addClass('error');
			$parent.addClass('error');
			
			var newHtml = '';
			if (typeInput != 'checkbox') {
				newHtml = msgErreurVide + $aModifier.html();
				newHtml += (erreurInt === true ? msgErreurInt : (erreurEmail === true ? msgErreurEmail : ''));
			} else {
				newHtml = $aModifier.html();
			}
			
			if (newHtml.indexOf(' *') > -1) {
				node.attr('data-etoile', '');
				newHtml = newHtml.replace(' *', '');
			}
			
			$aModifier.html(newHtml);
			
			retour = false;
		} else {
			$((typeInput === 'radio' ? 'input[data-oblig=1][name=' + $(this).attr('name') + ']' : $(this))).removeClass('error').addClass('valid');
			
			retour = true;
		}
	});
	
	return retour;
}

window.checkInput = checkInput


// WEBPACK FOOTER //
// ./resources/assets/js/lib/utils.js